import $ from 'jquery';
import React, {ElementType} from 'react';
import ReactDOM from 'react-dom/client';

import * as ReduxDOMRender from 'redux-stores/ReduxDOMRender';

// Because renderReactElement is always rendered to $('.react-mount'), we need to keep track of that root
// here, in a global, instead of per-caller
let reactRoot: ReactDOM.Root | null = null;

export function renderReactElement(element: JSX.Element): void {
  const $mount = $('.react-mount');
  if ($mount.length !== 1) {
    const count = $mount.length === 0 ? 'no' : 'multiple';
    throw new Error(`Cannot render React component - ${count} .react-mount found`);
  }
  reactRoot = ReduxDOMRender.renderToDOM(element, $mount[0], reactRoot);
}

export function renderReactComponent(Component: ElementType, componentProps: object = {}): void {
  renderReactElement(
    <Component {...componentProps} {...(window.bootstrap && window.bootstrap.componentProps)} />
  );
}
